/*
 * This file is generated by the workex CLI Tool
 *
 * Please visit https://workex.pistonite.dev for more information
 */

import type { RuntimeApp } from "../runtime_app.ts";

import type { WxPromise, WxBusRecvHandler, WxProtocolBoundSender } from "@pistonite/workex";
import type { ItemSearchResult } from "#types";

/*
 * These generated implementations are used internally by other generated code.
 * They should not be used directly!
 */

/**
 * API provided by the simulator app that the runtime needs to call
 */
export class _wxSenderImpl implements RuntimeApp {
    private sender: WxProtocolBoundSender

    constructor(sender: WxProtocolBoundSender) {
        this.sender = sender
    }

    /**
     * Signal the application to crash because unrecoverable error occurred in the runtime
     */
    public crashApplication( ): WxPromise<void> {
        return this.sender.sendVoid(56 /* RuntimeApp.crashApplication */, [ ]);
    }

    /**
     * Get the custom BlueFlame image provided by the user.
     * 
     * The runtime may request this if it's instructed to initialize
     * with a custom image. For the best user experience, the app should
     * prompt file selection and have the image ready before initializing,
     * and return the file in this callback.
     * 
     * If the user did not provide a custom image, the app should return undefined
     * in which case the runtime initialization will fail.
     */
    public getCustomBlueFlameImage( ): WxPromise<Uint8Array | undefined> {
        return this.sender.send<Uint8Array | undefined>(57 /* RuntimeApp.getCustomBlueFlameImage */, [ ]);
    }

    /**
     * Resolve a quoted item search query to a single item, or
     * return undefined if the item cannot be resolved due to error
     * or no match.
     */
    public resolveQuotedItem( query: string ): WxPromise<ItemSearchResult | undefined> {
        return this.sender.send<ItemSearchResult | undefined>(58 /* RuntimeApp.resolveQuotedItem */, [ query ]);
    }
}

/**
 * API provided by the simulator app that the runtime needs to call
 */
export const _wxRecverImpl = (handler: RuntimeApp): WxBusRecvHandler => {
    return ((fId, args: any[]) => { switch (fId) {
        case 56 /* RuntimeApp.crashApplication */: {
            return handler.crashApplication();
        }
        case 57 /* RuntimeApp.getCustomBlueFlameImage */: {
            return handler.getCustomBlueFlameImage();
        }
        case 58 /* RuntimeApp.resolveQuotedItem */: {
            const [ a0 ] = args;
            return handler.resolveQuotedItem( a0 );
        }
    } return Promise.resolve({ err: { code: "UnknownFunction" } }); }) as WxBusRecvHandler;
};